import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingPrice} from './pricing-price';

@JsonObject('model.PriceGrade')
export class PricingGrade extends AbstractModel {
  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(String, 'type')
  type?: string

  @JsonProperty([PricingPrice], 'prices')
  prices: PricingPrice[]

  @JsonProperty(Boolean, 'isDefault')
  isDefault?: boolean;

  @JsonProperty(String, 'description')
  description?: string
}

